import { Environment } from './environment.d';

export const environment: Environment = {
    production: false,
    environmentName: 'test',
    APIENDPOINT: 'https://tstcep-api.anchanto.com/',
    APIV1ENDPOINT: 'https://tstcep-api.anchanto.com/frontend/v1/',
    MPRETURNURL: 'https://omsqa.anchanto.com/cep-authorize',
    ruleEngineUrl: 'https://rules.anchanto.com/rule-engine',
    growMoreTenantId: 93,
    dpdTenantId: [58, 94, 100, 101],
    swiftHubTenantId: [22],
    transcorpTenantId: [46],
    multiLingualCustomerId: [475],
    churnZeroAppKey: '1!osTjZukP8dbUNA0TgB9ME4O91pDSH04xxnT6Jb-z1xAt14FB',
    printNodeIntelDownloadUrl: 'https://dl.printnode.com/client/anchanto/4.28.28/TestOXM-4.28.28.dmg'
};
